import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import { Page404 } from "pages";

import { Constants } from "appConstants";
import BackofficeRoutes from "./backoffice";

function Routers() {
	const { pathname } = useLocation();

	useEffect(() => {
		setTimeout(() => {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: "smooth"
			});
		}, 100);
	}, [pathname]);

	return (
		<Routes>
			<Route path="/" element={<BackofficeRoutes tabs={Constants.tabs} />} />
			<Route
				path="/backoffice/*"
				element={<BackofficeRoutes tabs={Constants.tabs} />}
			/>
			<Route path="/*" element={<Page404 />} />
		</Routes>
	);
}

export default Routers;
